module.exports = __webpack_public_path__ + "img/two-img.87769bcb.jpg";